import actions from '@/core/store/adesao/itens-adesao/estorno/historico/actions'

export default { actions }
